export default __webpack_public_path__ + "static/media/ic-credit-card.8e066051.svg";